import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import { useAuth } from '../AuthContext';

const ImageUploader = ({ uploadedImages, setUploadedImages, removeUploadedImages  }) => {
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
 

  const myContext = useAuth();
  const token = myContext.jwtToken;

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;
      acceptedFiles.forEach((file) => {
        uploadImage(file);
      });
    },
    [token]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      'image/*': [],
    },
  });

  const uploadImage = async (file) => {
    setUploading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await axios.post(
        'https://api.schedpilot.com/wp-json/custom/v1/upload-image',
        formData,
        {

          headers: {
 
            'Content-Type': 'multipart/form-data',
          },
            withCredentials: true,
        }
      );

      if (response.data.code === 200) {
        setMessage('Upload successful!');
        setUploadedImages((prev) => [
          ...prev,
          { url: response.data.file_url, id: response.data.image_id },
        ]);
      } else {
        setMessage('Upload failed.');
      }
    } catch (error) {
      console.error(error);
      setMessage('Error uploading image.');
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteImage = async (urlToDelete) => {
    try {
      const response = await axios.post(
        'https://api.schedpilot.com/wp-json/custom/v1/delete-image',
        { file_url: urlToDelete },
        {
          headers: {
 
          },
            withCredentials: true,
        }
      );

      if (response.data.code === 200) {
        setMessage('Image deleted.');
        setUploadedImages((prev) => prev.filter((img) => img.url !== urlToDelete));
      } else {
        setMessage('Failed to delete image.');
      }
    } catch (error) {
      console.error(error);
      setMessage('Error deleting image.');
    }
  };

  return (
    <div style={{ border: '2px dashed #ccc', padding: 20, borderRadius: 8, backgroundColor: '#fff', marginTop: 20 }}>
      <div {...getRootProps()} style={{ cursor: 'pointer', padding: 30, textAlign: 'center' }}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the image(s) here ...</p>
        ) : (
          <p>Drag & drop image(s) here, or click to select files</p>
        )}
      </div>

      {uploading && <p>Uploading...</p>}
      {message && <p>{message}</p>}

      {uploadedImages.length > 0 && (
        <div className="mt-3 d-flex" style={{backgroundColor:"#f2f2f2", padding: 10}}>
          {uploadedImages.map((img, index) => (
            <div className="d-flex flex-column mr-3 mb-3" key={index}>
              <img
                src={img.url}
                alt={`Uploaded ${index}`}
                className="img-thumbnail"
                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
              />
              <button
                className="btn btn-sm btn-danger mt-2" style={{borderRadius:5}}
                onClick={() => removeUploadedImages(index)}
                disabled={uploading}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
